module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "JWvideoHandler"
  }, [_c('div', {
    ref: _vm.playerID,
    attrs: {
      "id": _vm.playerID
    }
  }, [_vm._v("\n        Loading video...\n    ")]), _vm._v(" "), (_vm.showButtonFlag) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showButtonFlag) ? _c('button', {
    staticClass: "pink-button",
    style: ({
      'border-width': '1px !important',
      'border-style': 'solid !important',
      'border-color': this.getCorpButtonColor + ' !important',
      'color': '#FFFFF !important',
      'background-color': this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "id": "buyflow"
    },
    on: {
      "click": _vm.redirectUserToJoin
    }
  }, [_vm._v("Join Now")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.becomeMemberFlag) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.becomeMemberFlag) ? _c('button', {
    staticClass: "pink-button",
    attrs: {
      "id": "becomeMemberflow"
    },
    on: {
      "click": _vm.redirectUserToCompleteSignup
    }
  }, [_vm._v("Update my Membership")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ac67fc6", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac67fc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/JwPlayer.vue